// Internal Imports
import store from "../../store";
import { GRID } from "../../constants";
import { USER_ROLES } from "../../constants/roleList";

// Destructuring
const { GRID_PAGE_TYPE } = GRID;

export const parseColVisiblity = (obj, page) => {
  const reduxStore = store.getState();
  const { dealTableId } = reduxStore.QuotationStore;
  let columnDef = [];
  if (page === GRID_PAGE_TYPE.PRICELIST) {
    columnDef = reduxStore.PricebookStore.columnDefs;
  } else if (page === GRID_PAGE_TYPE.DEALTABLE) {
    columnDef = reduxStore.DealTableStore.columnDefs[dealTableId];
  }

  function _getRolesBasedOnPage(roles) {
    // SalesRep will not see pricebook menu option & hence showing that option in manage column is not needed
    if (page === GRID_PAGE_TYPE.PRICELIST) {
      return roles.filter(role => role.name !== USER_ROLES.USER);
    }
    return roles;
  }

  const finalObj = [];
  const columns = columnDef.filter(item => item.hidden === undefined); // Filter columns which are not hidden
  const roles = _getRolesBasedOnPage(obj[0].Roles); // RBAC Roles
  const visibilityList = obj[1].Visibility; // Existing column visibility list
  columns.forEach(column => {
    // Column data goes here
    const items = {
      title: column.headerName,
      id: column.columnId,
      options: [],
    };
    // Add visible status of columns for all the roles
    roles.forEach(role => {
      const roleStatus = {
        id: role.id,
        name: role.name,
        visible:
          Object.keys(visibilityList).length > 0 &&
          Object.keys(visibilityList[role.id]).includes(column.columnId)
            ? visibilityList[role.id][column.columnId]
            : true, // If key exists then use the value else set the columns to visible true
      };
      items.options[role.id] = roleStatus;
    });
    finalObj.push(items);
  });
  const titles = [
    ...["Columns"],
    ...finalObj[0].options.map(item => item.name),
  ]; // Create column headers to display in the top
  return {
    data: finalObj,
    roles,
    titles,
  };
};

export const parseAppFlags = flags => {
  if (flags && flags.length > 0) {
    const payload = {};
    flags.forEach(data => {
      payload[data.flag] = data.value;
    });
    return payload;
  }
  return {};
};



// WEBPACK FOOTER //
// ./src/actions/CommonActions/commonMethods.js